export default __webpack_public_path__ + "static/media/print.aae124df.svg";